import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { FiberManualRecord as DotIcon } from "@mui/icons-material";
import { Field, useField } from "formik";
import { PropTypes } from "prop-types";
import { enrollmentScoreIconColors } from "../../constants";
import { TextField } from "formik-mui";

const useStyles = makeStyles(theme => ({
  dotIcon: {
    fontSize: "0.75rem",
    marginRight: theme.spacing(0.75)
  },
  scoreField: {
    height: 40,
    width: 80
  }
}));

const getScoreColor = (color, theme) => {
  switch (color) {
    case enrollmentScoreIconColors.green:
      return theme.palette.success.main;
    case enrollmentScoreIconColors.yellow:
      return theme.palette.warning.main;
    case enrollmentScoreIconColors.red:
      return theme.palette.error.main;
    default:
      return theme.palette.common.white;
  }
};

const EditableScore = ({ postScore, rowIndex }) => {
  const classes = useStyles();
  const [{ name, value }, , { setValue }] = useField(
    `enrollments[${rowIndex}].postScore`
  );

  useEffect(() => {
    if (!!value && !Number.isInteger(value)) {
      setValue(parseInt(value.toString().replace(/[^0-9]/g, "")));
    }
  }, [value]);

  return (
    <Field
      component={TextField}
      variant="filled"
      name={name}
      fullWidth
      InputProps={{
        className: classes.scoreField,
        inputProps: { type: "number", min: 0 }
      }}
      error={postScore < 0}
      data-qa="paper-based-test-score-field"
      hiddenLabel
    />
  );
};

const AdminScoreCell = ({ scoreData, postScore, isEditable, rowIndex }) => {
  const classes = useStyles();
  const theme = useTheme();
  const scoreColor = getScoreColor(scoreData ? scoreData.icon : null, theme);

  return (
    <Box display="flex" alignItems="center">
      {isEditable ? (
        <EditableScore
          scoreData={scoreData}
          postScore={postScore}
          rowIndex={rowIndex}
        />
      ) : (
        <>
          <DotIcon className={classes.dotIcon} htmlColor={scoreColor} />
          <Typography variant="body2" noWrap>
            {scoreData ? scoreData.label : ""}
          </Typography>
        </>
      )}
    </Box>
  );
};

AdminScoreCell.propTypes = {
  scoreData: PropTypes.shape({
    icon: PropTypes.oneOf(["red", "green", "yellow"]),
    label: PropTypes.string
  }),
  postScore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isEditable: PropTypes.bool,
  onScoreChange: PropTypes.func
};

export default AdminScoreCell;
